import axios from "axios";
import { enqueueSnackbar } from "notistack";

/**
 * Специальный клиент для загрузки бинарных файлов (изображений, аудио и т.д.)
 */
export const apiClientBlob = async (
  url: string,
  method: string = "GET",
  token?: string
): Promise<Blob> => {
  const bearer =
    token || (typeof window !== "undefined" ? localStorage.getItem("token") : "");

    try {
    const response = await axios.request({
      url,
      method,
      baseURL: "https://messenger.factfactor.ru",
      responseType: "blob", 
      headers: {
        Authorization: bearer ? `Bearer ${bearer}` : "",
      },
    });

    if (![200, 201, 204].includes(response.status)) {
      throw new Error("Failed to load file");
    }

    return response.data;
  } catch (err: any) {
    console.error("File load error:", err);

    if (err?.response?.status === 401) {
      enqueueSnackbar("Не авторизован", { variant: "error" });
    } else {
      enqueueSnackbar("Не удалось загрузить файл", { variant: "error" });
    }

    throw err;
  }
};